import { useSelector } from 'react-redux'
import { Panel } from '../../common/panel'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../common/selectCurrencyUnit/useFormatCurrency'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import { PANEL_ID } from './helper'
import {
  selectOverdueSocialInsuranceIds,
  selectOverdueTaxDebt,
} from './store/slice'
import {
  exportOverdueSocialInsurance,
  exportOverdueTaxDebt,
} from './store/thunk'

export const PanelItem = ({ item }) => {
  const { organizationId } = useSelector(selectCompanyInfo)
  const { multiplier, currency, unitName } = useFormatCurrency(
    SCREEN.FILING_STATUS,
  )

  const isOverdueTaxDebtHasData = useSelector(
    selectOverdueTaxDebt(
      (data) =>
        data?.overdueTaxDebtHistory?.length ||
        data?.invoiceEnforcementHistory?.length,
    ),
  )
  const isOverdueSocialInsuranceHasData = useSelector(
    selectOverdueSocialInsuranceIds((data) => !!data.length),
  )

  const getDownloadCsv = () => {
    const params = {
      organizationId,
      currency,
      currencyUnit: {
        multiplier,
        value: unitName,
        en_Value: unitName,
      },
    }

    switch (item.id) {
      case PANEL_ID.OVERDUE_TAX_DEBT:
        return {
          downloadFunc: () => exportOverdueTaxDebt(params),
          disabled: !isOverdueTaxDebtHasData,
        }
      case PANEL_ID.OVERDUE_SOCIAL_INSURANCE:
        return {
          downloadFunc: () => exportOverdueSocialInsurance(params),
          disabled: !isOverdueSocialInsuranceHasData,
        }
      default:
        break
    }
  }

  const ItemComponent = item.component

  return (
    <Panel
      id={item.id}
      label={item.label}
      type={item.type}
      isI18n
      style={{ height: 'unset' }}
      downloadCsv={getDownloadCsv()}
    >
      <ItemComponent />
    </Panel>
  )
}
